export default __webpack_public_path__ + "static/media/decada-2010-0002-min.d7acb61b.JPG";